<template>
  <body class="body-container">
    <div class="box-notfound">
      <h2 style="font-size: 24px; font-weight: 800; width: 100%; padding: 20px;">ページが見つかりませんでした。</h2>
      <template v-if="isLoading">
        <span class="mdi mdi-loading mdi-spin"></span>
      </template>
      <template v-else-if="company.company_name && company.company_url">
        <a :href="company.company_url">{{company.company_name}}のホームページに戻る</a>
      </template>
      <template v-else>
        <a href="/">TOPに戻る</a>
      </template>
    </div>
  </body>
</template>

<script>
export default {
  name: 'NotFound',
  componentName: 'NotFound',
  data () {
    return {
      company: {
        company_name: null,
        company_url: null
      },
      isLoading: true
    }
  },
  created () {
    if (this.$route.query.cid) {
      this.$store.dispatch('auth/getCompanyAny', this.$route.query.cid)
        .then((d) => {
          this.company = d
          this.isLoading = false
        })
    } else {
      this.isLoading = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box-notfound {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: url('../../assets/lp/pattern.png') repeat;
}
</style>



// WEBPACK FOOTER //
// src/views/NotFound/404.vue